// source: talk-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.talk_api.AssistantMessagingRequest', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingRequest.RequestCase', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse.DataCase', null, global);
goog.exportSymbol('proto.talk_api.CreateBulkPhoneCallRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateBulkPhoneCallResponse', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricResponse', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricResponse', null, global);
goog.exportSymbol('proto.talk_api.CreatePhoneCallRequest', null, global);
goog.exportSymbol('proto.talk_api.CreatePhoneCallResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.AssistantMessagingRequest.oneofGroups_);
};
goog.inherits(proto.talk_api.AssistantMessagingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingRequest.displayName = 'proto.talk_api.AssistantMessagingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.AssistantMessagingResponse.oneofGroups_);
};
goog.inherits(proto.talk_api.AssistantMessagingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingResponse.displayName = 'proto.talk_api.AssistantMessagingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricRequest.displayName = 'proto.talk_api.CreateMessageMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricResponse.displayName = 'proto.talk_api.CreateMessageMetricResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricRequest.displayName = 'proto.talk_api.CreateConversationMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricResponse.displayName = 'proto.talk_api.CreateConversationMetricResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreatePhoneCallRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.CreatePhoneCallRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreatePhoneCallRequest.displayName = 'proto.talk_api.CreatePhoneCallRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreatePhoneCallResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.CreatePhoneCallResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreatePhoneCallResponse.displayName = 'proto.talk_api.CreatePhoneCallResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateBulkPhoneCallRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateBulkPhoneCallRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateBulkPhoneCallRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateBulkPhoneCallRequest.displayName = 'proto.talk_api.CreateBulkPhoneCallRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateBulkPhoneCallResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateBulkPhoneCallResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateBulkPhoneCallResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateBulkPhoneCallResponse.displayName = 'proto.talk_api.CreateBulkPhoneCallResponse';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.AssistantMessagingRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.talk_api.AssistantMessagingRequest.RequestCase = {
  REQUEST_NOT_SET: 0,
  CONFIGURATION: 2,
  MESSAGE: 3
};

/**
 * @return {proto.talk_api.AssistantMessagingRequest.RequestCase}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getRequestCase = function() {
  return /** @type {proto.talk_api.AssistantMessagingRequest.RequestCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.AssistantMessagingRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configuration: (f = msg.getConfiguration()) && common_pb.AssistantConversationConfiguration.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.AssistantConversationUserMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingRequest;
  return proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new common_pb.AssistantConversationConfiguration;
      reader.readMessage(value,common_pb.AssistantConversationConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 3:
      var value = new common_pb.AssistantConversationUserMessage;
      reader.readMessage(value,common_pb.AssistantConversationUserMessage.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.AssistantConversationConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.AssistantConversationUserMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantConversationConfiguration configuration = 2;
 * @return {?proto.AssistantConversationConfiguration}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getConfiguration = function() {
  return /** @type{?proto.AssistantConversationConfiguration} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationConfiguration, 2));
};


/**
 * @param {?proto.AssistantConversationConfiguration|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.talk_api.AssistantMessagingRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AssistantConversationUserMessage message = 3;
 * @return {?proto.AssistantConversationUserMessage}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getMessage = function() {
  return /** @type{?proto.AssistantConversationUserMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationUserMessage, 3));
};


/**
 * @param {?proto.AssistantConversationUserMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.talk_api.AssistantMessagingRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.AssistantMessagingResponse.oneofGroups_ = [[9,10,11,12,13,14,15,16,17,18,19,20,21]];

/**
 * @enum {number}
 */
proto.talk_api.AssistantMessagingResponse.DataCase = {
  DATA_NOT_SET: 0,
  CONFIGURATION: 9,
  INTERRUPTION: 10,
  USER: 11,
  ASSISTANT: 12,
  MESSAGE: 13,
  DISCONNECTACTION: 14,
  HOLDACTION: 15,
  KNOWLEDGERETRIEVALACTION: 16,
  APIREQUESTACTION: 17,
  ENDPOINTACTION: 18,
  DEVIATIONACTION: 19,
  ASSISTANTTRANSFERACTION: 20,
  PHONECALLTRANSFERACTION: 21
};

/**
 * @return {proto.talk_api.AssistantMessagingResponse.DataCase}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getDataCase = function() {
  return /** @type {proto.talk_api.AssistantMessagingResponse.DataCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    configuration: (f = msg.getConfiguration()) && common_pb.AssistantConversationConfiguration.toObject(includeInstance, f),
    interruption: (f = msg.getInterruption()) && common_pb.AssistantConversationInterruption.toObject(includeInstance, f),
    user: (f = msg.getUser()) && common_pb.AssistantConversationUserMessage.toObject(includeInstance, f),
    assistant: (f = msg.getAssistant()) && common_pb.AssistantConversationAssistantMessage.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.AssistantConversationMessage.toObject(includeInstance, f),
    disconnectaction: (f = msg.getDisconnectaction()) && common_pb.AssistantConversationDisconnectAction.toObject(includeInstance, f),
    holdaction: (f = msg.getHoldaction()) && common_pb.AssistantConverstationHoldAction.toObject(includeInstance, f),
    knowledgeretrievalaction: (f = msg.getKnowledgeretrievalaction()) && common_pb.AssistantConverstationKnowledgeRetrievalAction.toObject(includeInstance, f),
    apirequestaction: (f = msg.getApirequestaction()) && common_pb.AssistantConverstationApiRequestAction.toObject(includeInstance, f),
    endpointaction: (f = msg.getEndpointaction()) && common_pb.AssistantConverstationEndpointAction.toObject(includeInstance, f),
    deviationaction: (f = msg.getDeviationaction()) && common_pb.AssistantConversationDeviationAction.toObject(includeInstance, f),
    assistanttransferaction: (f = msg.getAssistanttransferaction()) && common_pb.AssistantConversationAssistantTransferAction.toObject(includeInstance, f),
    phonecalltransferaction: (f = msg.getPhonecalltransferaction()) && common_pb.AssistantConversationPhoneCallTransferAction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingResponse;
  return proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 9:
      var value = new common_pb.AssistantConversationConfiguration;
      reader.readMessage(value,common_pb.AssistantConversationConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 10:
      var value = new common_pb.AssistantConversationInterruption;
      reader.readMessage(value,common_pb.AssistantConversationInterruption.deserializeBinaryFromReader);
      msg.setInterruption(value);
      break;
    case 11:
      var value = new common_pb.AssistantConversationUserMessage;
      reader.readMessage(value,common_pb.AssistantConversationUserMessage.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 12:
      var value = new common_pb.AssistantConversationAssistantMessage;
      reader.readMessage(value,common_pb.AssistantConversationAssistantMessage.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 13:
      var value = new common_pb.AssistantConversationMessage;
      reader.readMessage(value,common_pb.AssistantConversationMessage.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 14:
      var value = new common_pb.AssistantConversationDisconnectAction;
      reader.readMessage(value,common_pb.AssistantConversationDisconnectAction.deserializeBinaryFromReader);
      msg.setDisconnectaction(value);
      break;
    case 15:
      var value = new common_pb.AssistantConverstationHoldAction;
      reader.readMessage(value,common_pb.AssistantConverstationHoldAction.deserializeBinaryFromReader);
      msg.setHoldaction(value);
      break;
    case 16:
      var value = new common_pb.AssistantConverstationKnowledgeRetrievalAction;
      reader.readMessage(value,common_pb.AssistantConverstationKnowledgeRetrievalAction.deserializeBinaryFromReader);
      msg.setKnowledgeretrievalaction(value);
      break;
    case 17:
      var value = new common_pb.AssistantConverstationApiRequestAction;
      reader.readMessage(value,common_pb.AssistantConverstationApiRequestAction.deserializeBinaryFromReader);
      msg.setApirequestaction(value);
      break;
    case 18:
      var value = new common_pb.AssistantConverstationEndpointAction;
      reader.readMessage(value,common_pb.AssistantConverstationEndpointAction.deserializeBinaryFromReader);
      msg.setEndpointaction(value);
      break;
    case 19:
      var value = new common_pb.AssistantConversationDeviationAction;
      reader.readMessage(value,common_pb.AssistantConversationDeviationAction.deserializeBinaryFromReader);
      msg.setDeviationaction(value);
      break;
    case 20:
      var value = new common_pb.AssistantConversationAssistantTransferAction;
      reader.readMessage(value,common_pb.AssistantConversationAssistantTransferAction.deserializeBinaryFromReader);
      msg.setAssistanttransferaction(value);
      break;
    case 21:
      var value = new common_pb.AssistantConversationPhoneCallTransferAction;
      reader.readMessage(value,common_pb.AssistantConversationPhoneCallTransferAction.deserializeBinaryFromReader);
      msg.setPhonecalltransferaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.AssistantConversationConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getInterruption();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.AssistantConversationInterruption.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.AssistantConversationUserMessage.serializeBinaryToWriter
    );
  }
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.AssistantConversationAssistantMessage.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.AssistantConversationMessage.serializeBinaryToWriter
    );
  }
  f = message.getDisconnectaction();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.AssistantConversationDisconnectAction.serializeBinaryToWriter
    );
  }
  f = message.getHoldaction();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      common_pb.AssistantConverstationHoldAction.serializeBinaryToWriter
    );
  }
  f = message.getKnowledgeretrievalaction();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.AssistantConverstationKnowledgeRetrievalAction.serializeBinaryToWriter
    );
  }
  f = message.getApirequestaction();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.AssistantConverstationApiRequestAction.serializeBinaryToWriter
    );
  }
  f = message.getEndpointaction();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      common_pb.AssistantConverstationEndpointAction.serializeBinaryToWriter
    );
  }
  f = message.getDeviationaction();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      common_pb.AssistantConversationDeviationAction.serializeBinaryToWriter
    );
  }
  f = message.getAssistanttransferaction();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      common_pb.AssistantConversationAssistantTransferAction.serializeBinaryToWriter
    );
  }
  f = message.getPhonecalltransferaction();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      common_pb.AssistantConversationPhoneCallTransferAction.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AssistantConversationConfiguration configuration = 9;
 * @return {?proto.AssistantConversationConfiguration}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.AssistantConversationConfiguration} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationConfiguration, 9));
};


/**
 * @param {?proto.AssistantConversationConfiguration|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AssistantConversationInterruption interruption = 10;
 * @return {?proto.AssistantConversationInterruption}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getInterruption = function() {
  return /** @type{?proto.AssistantConversationInterruption} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationInterruption, 10));
};


/**
 * @param {?proto.AssistantConversationInterruption|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setInterruption = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearInterruption = function() {
  return this.setInterruption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasInterruption = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional AssistantConversationUserMessage user = 11;
 * @return {?proto.AssistantConversationUserMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getUser = function() {
  return /** @type{?proto.AssistantConversationUserMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationUserMessage, 11));
};


/**
 * @param {?proto.AssistantConversationUserMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional AssistantConversationAssistantMessage assistant = 12;
 * @return {?proto.AssistantConversationAssistantMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getAssistant = function() {
  return /** @type{?proto.AssistantConversationAssistantMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationAssistantMessage, 12));
};


/**
 * @param {?proto.AssistantConversationAssistantMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setAssistant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AssistantConversationMessage message = 13;
 * @return {?proto.AssistantConversationMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getMessage = function() {
  return /** @type{?proto.AssistantConversationMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationMessage, 13));
};


/**
 * @param {?proto.AssistantConversationMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional AssistantConversationDisconnectAction disconnectAction = 14;
 * @return {?proto.AssistantConversationDisconnectAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getDisconnectaction = function() {
  return /** @type{?proto.AssistantConversationDisconnectAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationDisconnectAction, 14));
};


/**
 * @param {?proto.AssistantConversationDisconnectAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setDisconnectaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearDisconnectaction = function() {
  return this.setDisconnectaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasDisconnectaction = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional AssistantConverstationHoldAction holdAction = 15;
 * @return {?proto.AssistantConverstationHoldAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getHoldaction = function() {
  return /** @type{?proto.AssistantConverstationHoldAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConverstationHoldAction, 15));
};


/**
 * @param {?proto.AssistantConverstationHoldAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setHoldaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearHoldaction = function() {
  return this.setHoldaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasHoldaction = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional AssistantConverstationKnowledgeRetrievalAction knowledgeRetrievalAction = 16;
 * @return {?proto.AssistantConverstationKnowledgeRetrievalAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getKnowledgeretrievalaction = function() {
  return /** @type{?proto.AssistantConverstationKnowledgeRetrievalAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConverstationKnowledgeRetrievalAction, 16));
};


/**
 * @param {?proto.AssistantConverstationKnowledgeRetrievalAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setKnowledgeretrievalaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearKnowledgeretrievalaction = function() {
  return this.setKnowledgeretrievalaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasKnowledgeretrievalaction = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional AssistantConverstationApiRequestAction apiRequestAction = 17;
 * @return {?proto.AssistantConverstationApiRequestAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getApirequestaction = function() {
  return /** @type{?proto.AssistantConverstationApiRequestAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConverstationApiRequestAction, 17));
};


/**
 * @param {?proto.AssistantConverstationApiRequestAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setApirequestaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearApirequestaction = function() {
  return this.setApirequestaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasApirequestaction = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional AssistantConverstationEndpointAction endpointAction = 18;
 * @return {?proto.AssistantConverstationEndpointAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getEndpointaction = function() {
  return /** @type{?proto.AssistantConverstationEndpointAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConverstationEndpointAction, 18));
};


/**
 * @param {?proto.AssistantConverstationEndpointAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setEndpointaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearEndpointaction = function() {
  return this.setEndpointaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasEndpointaction = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional AssistantConversationDeviationAction deviationAction = 19;
 * @return {?proto.AssistantConversationDeviationAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getDeviationaction = function() {
  return /** @type{?proto.AssistantConversationDeviationAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationDeviationAction, 19));
};


/**
 * @param {?proto.AssistantConversationDeviationAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setDeviationaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearDeviationaction = function() {
  return this.setDeviationaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasDeviationaction = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional AssistantConversationAssistantTransferAction assistantTransferAction = 20;
 * @return {?proto.AssistantConversationAssistantTransferAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getAssistanttransferaction = function() {
  return /** @type{?proto.AssistantConversationAssistantTransferAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationAssistantTransferAction, 20));
};


/**
 * @param {?proto.AssistantConversationAssistantTransferAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setAssistanttransferaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearAssistanttransferaction = function() {
  return this.setAssistanttransferaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasAssistanttransferaction = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional AssistantConversationPhoneCallTransferAction phoneCallTransferAction = 21;
 * @return {?proto.AssistantConversationPhoneCallTransferAction}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getPhonecalltransferaction = function() {
  return /** @type{?proto.AssistantConversationPhoneCallTransferAction} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationPhoneCallTransferAction, 21));
};


/**
 * @param {?proto.AssistantConversationPhoneCallTransferAction|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setPhonecalltransferaction = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearPhonecalltransferaction = function() {
  return this.setPhonecalltransferaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasPhonecalltransferaction = function() {
  return jspb.Message.getField(this, 21) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    messageid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricRequest;
  return proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 4:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string messageId = 3;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setMessageid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Metric metrics = 4;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 4));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
*/
proto.talk_api.CreateMessageMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricResponse;
  return proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricRequest;
  return proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * repeated Metric metrics = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
*/
proto.talk_api.CreateConversationMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricResponse;
  return proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreatePhoneCallRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreatePhoneCallRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreatePhoneCallRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistant: (f = msg.getAssistant()) && common_pb.AssistantDefinition.toObject(includeInstance, f),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    argsMap: (f = msg.getArgsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    fromnumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tonumber: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreatePhoneCallRequest}
 */
proto.talk_api.CreatePhoneCallRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreatePhoneCallRequest;
  return proto.talk_api.CreatePhoneCallRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreatePhoneCallRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreatePhoneCallRequest}
 */
proto.talk_api.CreatePhoneCallRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.AssistantDefinition;
      reader.readMessage(value,common_pb.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 3:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 4:
      var value = msg.getArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 5:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromnumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTonumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreatePhoneCallRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreatePhoneCallRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreatePhoneCallRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getArgsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getFromnumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTonumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional AssistantDefinition assistant = 1;
 * @return {?proto.AssistantDefinition}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getAssistant = function() {
  return /** @type{?proto.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantDefinition, 1));
};


/**
 * @param {?proto.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
*/
proto.talk_api.CreatePhoneCallRequest.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, google.protobuf.Any> metadata = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> args = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.clearArgsMap = function() {
  this.getArgsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> options = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;};


/**
 * optional string fromNumber = 6;
 * @return {string}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getFromnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.setFromnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string toNumber = 7;
 * @return {string}
 */
proto.talk_api.CreatePhoneCallRequest.prototype.getTonumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreatePhoneCallRequest} returns this
 */
proto.talk_api.CreatePhoneCallRequest.prototype.setTonumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreatePhoneCallResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreatePhoneCallResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreatePhoneCallResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && common_pb.AssistantConversation.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreatePhoneCallResponse}
 */
proto.talk_api.CreatePhoneCallResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreatePhoneCallResponse;
  return proto.talk_api.CreatePhoneCallResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreatePhoneCallResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreatePhoneCallResponse}
 */
proto.talk_api.CreatePhoneCallResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.AssistantConversation;
      reader.readMessage(value,common_pb.AssistantConversation.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreatePhoneCallResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreatePhoneCallResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreatePhoneCallResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.AssistantConversation.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
 */
proto.talk_api.CreatePhoneCallResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
 */
proto.talk_api.CreatePhoneCallResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantConversation data = 3;
 * @return {?proto.AssistantConversation}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.getData = function() {
  return /** @type{?proto.AssistantConversation} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversation, 3));
};


/**
 * @param {?proto.AssistantConversation|undefined} value
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
*/
proto.talk_api.CreatePhoneCallResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
 */
proto.talk_api.CreatePhoneCallResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
*/
proto.talk_api.CreatePhoneCallResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreatePhoneCallResponse} returns this
 */
proto.talk_api.CreatePhoneCallResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreatePhoneCallResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateBulkPhoneCallRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateBulkPhoneCallRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateBulkPhoneCallRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateBulkPhoneCallRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateBulkPhoneCallRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    phonecallsList: jspb.Message.toObjectList(msg.getPhonecallsList(),
    proto.talk_api.CreatePhoneCallRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateBulkPhoneCallRequest}
 */
proto.talk_api.CreateBulkPhoneCallRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateBulkPhoneCallRequest;
  return proto.talk_api.CreateBulkPhoneCallRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateBulkPhoneCallRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateBulkPhoneCallRequest}
 */
proto.talk_api.CreateBulkPhoneCallRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 6:
      var value = new proto.talk_api.CreatePhoneCallRequest;
      reader.readMessage(value,proto.talk_api.CreatePhoneCallRequest.deserializeBinaryFromReader);
      msg.addPhonecalls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateBulkPhoneCallRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateBulkPhoneCallRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateBulkPhoneCallRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateBulkPhoneCallRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhonecallsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.talk_api.CreatePhoneCallRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CreatePhoneCallRequest phoneCalls = 6;
 * @return {!Array<!proto.talk_api.CreatePhoneCallRequest>}
 */
proto.talk_api.CreateBulkPhoneCallRequest.prototype.getPhonecallsList = function() {
  return /** @type{!Array<!proto.talk_api.CreatePhoneCallRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.talk_api.CreatePhoneCallRequest, 6));
};


/**
 * @param {!Array<!proto.talk_api.CreatePhoneCallRequest>} value
 * @return {!proto.talk_api.CreateBulkPhoneCallRequest} returns this
*/
proto.talk_api.CreateBulkPhoneCallRequest.prototype.setPhonecallsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.talk_api.CreatePhoneCallRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.talk_api.CreatePhoneCallRequest}
 */
proto.talk_api.CreateBulkPhoneCallRequest.prototype.addPhonecalls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.talk_api.CreatePhoneCallRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateBulkPhoneCallRequest} returns this
 */
proto.talk_api.CreateBulkPhoneCallRequest.prototype.clearPhonecallsList = function() {
  return this.setPhonecallsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateBulkPhoneCallResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateBulkPhoneCallResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateBulkPhoneCallResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateBulkPhoneCallResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.AssistantConversation.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse}
 */
proto.talk_api.CreateBulkPhoneCallResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateBulkPhoneCallResponse;
  return proto.talk_api.CreateBulkPhoneCallResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateBulkPhoneCallResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse}
 */
proto.talk_api.CreateBulkPhoneCallResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.AssistantConversation;
      reader.readMessage(value,common_pb.AssistantConversation.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateBulkPhoneCallResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateBulkPhoneCallResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateBulkPhoneCallResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.AssistantConversation.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated AssistantConversation data = 3;
 * @return {!Array<!proto.AssistantConversation>}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.AssistantConversation>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.AssistantConversation, 3));
};


/**
 * @param {!Array<!proto.AssistantConversation>} value
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
*/
proto.talk_api.CreateBulkPhoneCallResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.AssistantConversation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.AssistantConversation}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.AssistantConversation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
*/
proto.talk_api.CreateBulkPhoneCallResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateBulkPhoneCallResponse} returns this
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateBulkPhoneCallResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.talk_api);
